module.exports = __webpack_public_path__ + "img/114.5276851.jpg";